import { InfoOutlined, RefreshOutlined } from "@material-ui/icons";
import StyledToolTip from "../../../common/StyledToolTip";
import { REVERT_COLUMN_CONFIG } from "./constant";
import { withStyles } from "@material-ui/core";


const styles = () => ({
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  revertIcon: {
    transform: 'scale(-1,1)'
  }
});
const RevertRenderer = ({ originalValue, classes, gridParams }) => {
  const {
    colDef: { field },
    api
  } = gridParams;
  const fieldConfig = REVERT_COLUMN_CONFIG[field];
  return gridParams.data[fieldConfig.isModifiedField] ? (
    <div className={classes.container}>
      <StyledToolTip
        title={
          <div>
            <div>Updated by planner</div> <div>Original {originalValue}</div>
          </div>
        }>
        <InfoOutlined color="primary" className="pointer-cell" />
      </StyledToolTip>
      <StyledToolTip title={fieldConfig?.revertIconTooltipTitle}>
        <div
          onClick={() => api.runCommand('revert', { field })}
          className="pointer-cell">
          <RefreshOutlined className={classes.revertIcon} />
        </div>
      </StyledToolTip>
    </div>
  ) : null;
};

export default withStyles(styles)(RevertRenderer);
